import { createMemoStyles } from "@wds/utils";
import { HeaderTheme } from "../../theme";

const useStyles = createMemoStyles(({ palette }: HeaderTheme) => ({
  logo: {
    color: palette.background.light
  },
}));

export default useStyles;
